"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ProductVATByProductData_1 = require("./ProductVATByProductData");
/**
 * Aggregation of {@link ProductVAT product VAT} over {@link ProductVAT.productId}.
 *
 * @author JMe
 */


var ProductVATByProduct =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductVATByProduct, _DomainObject_1$Domai);

  /**
   * @param productId internal id of internal product
   * @param dataPerProduct list of all remaining data per product
   */
  function ProductVATByProduct(productId, dataPerProduct) {
    var _this;

    _classCallCheck(this, ProductVATByProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProduct).call(this));
    _this.productId = productId;
    _this.dataPerProduct = dataPerProduct;
    return _this;
  }

  return ProductVATByProduct;
}(DomainObject_1.DomainObject);

exports.ProductVATByProduct = ProductVATByProduct;

ProductVATByProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductVATByProduct.name);
  return {
    productId: builder.id('productId'),
    dataPerProduct: builder.listOf(builder.obj('dataPerProduct', ProductVATByProductData_1.ProductVATByProductData.schema, function (mat) {
      return ProductVATByProductData_1.ProductVATByProductData.fromDataDict(mat);
    }))
  };
}();